// ── BB ARTICLE: POST PAGE ──
document.addEventListener('DOMContentLoaded', function () {

  // ── COPY LINK ──
  const copyBtn = document.querySelector('.bba-share-copy');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(window.location.href).then(function () {
        const original = copyBtn.textContent;
        copyBtn.textContent = '✓ Copied!';
        setTimeout(function () { copyBtn.textContent = original; }, 2000);
      });
    });
  }

});
